import { render } from "./UserDetailsView.vue?vue&type=template&id=cfad9280"
import script from "./UserDetailsView.vue?vue&type=script&lang=js"
export * from "./UserDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__